// source: trafficUpdates.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.TrafficUpdates.CourierPosition', null, global);
goog.exportSymbol('proto.TrafficUpdates.CourierPositionsRequest', null, global);
goog.exportSymbol('proto.TrafficUpdates.CourierPositionsResponse', null, global);
goog.exportSymbol('proto.TrafficUpdates.CouriersLastPositionsRequest', null, global);
goog.exportSymbol('proto.TrafficUpdates.CouriersLastPositionsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrafficUpdates.CourierPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrafficUpdates.CourierPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrafficUpdates.CourierPosition.displayName = 'proto.TrafficUpdates.CourierPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrafficUpdates.CourierPositionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.TrafficUpdates.CourierPositionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrafficUpdates.CourierPositionsRequest.displayName = 'proto.TrafficUpdates.CourierPositionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrafficUpdates.CourierPositionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrafficUpdates.CourierPositionsResponse.repeatedFields_, null);
};
goog.inherits(proto.TrafficUpdates.CourierPositionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrafficUpdates.CourierPositionsResponse.displayName = 'proto.TrafficUpdates.CourierPositionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrafficUpdates.CouriersLastPositionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrafficUpdates.CouriersLastPositionsRequest.repeatedFields_, null);
};
goog.inherits(proto.TrafficUpdates.CouriersLastPositionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrafficUpdates.CouriersLastPositionsRequest.displayName = 'proto.TrafficUpdates.CouriersLastPositionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.TrafficUpdates.CouriersLastPositionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.TrafficUpdates.CouriersLastPositionsResponse.repeatedFields_, null);
};
goog.inherits(proto.TrafficUpdates.CouriersLastPositionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.TrafficUpdates.CouriersLastPositionsResponse.displayName = 'proto.TrafficUpdates.CouriersLastPositionsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrafficUpdates.CourierPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.TrafficUpdates.CourierPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrafficUpdates.CourierPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
    latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    courierId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dateTime: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrafficUpdates.CourierPosition}
 */
proto.TrafficUpdates.CourierPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrafficUpdates.CourierPosition;
  return proto.TrafficUpdates.CourierPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrafficUpdates.CourierPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrafficUpdates.CourierPosition}
 */
proto.TrafficUpdates.CourierPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourierId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrafficUpdates.CourierPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrafficUpdates.CourierPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrafficUpdates.CourierPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCourierId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDateTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional double latitude = 1;
 * @return {number}
 */
proto.TrafficUpdates.CourierPosition.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.TrafficUpdates.CourierPosition} returns this
 */
proto.TrafficUpdates.CourierPosition.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.TrafficUpdates.CourierPosition.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.TrafficUpdates.CourierPosition} returns this
 */
proto.TrafficUpdates.CourierPosition.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 courier_id = 3;
 * @return {number}
 */
proto.TrafficUpdates.CourierPosition.prototype.getCourierId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrafficUpdates.CourierPosition} returns this
 */
proto.TrafficUpdates.CourierPosition.prototype.setCourierId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string date_time = 4;
 * @return {string}
 */
proto.TrafficUpdates.CourierPosition.prototype.getDateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrafficUpdates.CourierPosition} returns this
 */
proto.TrafficUpdates.CourierPosition.prototype.setDateTime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.TrafficUpdates.CourierPositionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrafficUpdates.CourierPositionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPositionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    courierId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    dateTime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrafficUpdates.CourierPositionsRequest}
 */
proto.TrafficUpdates.CourierPositionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrafficUpdates.CourierPositionsRequest;
  return proto.TrafficUpdates.CourierPositionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrafficUpdates.CourierPositionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrafficUpdates.CourierPositionsRequest}
 */
proto.TrafficUpdates.CourierPositionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourierId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrafficUpdates.CourierPositionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrafficUpdates.CourierPositionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPositionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourierId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDateTime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 courier_id = 1;
 * @return {number}
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.getCourierId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.TrafficUpdates.CourierPositionsRequest} returns this
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.setCourierId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string date_time = 2;
 * @return {string}
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.getDateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrafficUpdates.CourierPositionsRequest} returns this
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.setDateTime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string country_code = 3;
 * @return {string}
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrafficUpdates.CourierPositionsRequest} returns this
 */
proto.TrafficUpdates.CourierPositionsRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrafficUpdates.CourierPositionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrafficUpdates.CourierPositionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.TrafficUpdates.CourierPositionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrafficUpdates.CourierPositionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPositionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    courierPositionsList: jspb.Message.toObjectList(msg.getCourierPositionsList(),
    proto.TrafficUpdates.CourierPosition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrafficUpdates.CourierPositionsResponse}
 */
proto.TrafficUpdates.CourierPositionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrafficUpdates.CourierPositionsResponse;
  return proto.TrafficUpdates.CourierPositionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrafficUpdates.CourierPositionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrafficUpdates.CourierPositionsResponse}
 */
proto.TrafficUpdates.CourierPositionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.TrafficUpdates.CourierPosition;
      reader.readMessage(value,proto.TrafficUpdates.CourierPosition.deserializeBinaryFromReader);
      msg.addCourierPositions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrafficUpdates.CourierPositionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrafficUpdates.CourierPositionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrafficUpdates.CourierPositionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CourierPositionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourierPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.TrafficUpdates.CourierPosition.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CourierPosition courier_positions = 1;
 * @return {!Array<!proto.TrafficUpdates.CourierPosition>}
 */
proto.TrafficUpdates.CourierPositionsResponse.prototype.getCourierPositionsList = function() {
  return /** @type{!Array<!proto.TrafficUpdates.CourierPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrafficUpdates.CourierPosition, 1));
};


/**
 * @param {!Array<!proto.TrafficUpdates.CourierPosition>} value
 * @return {!proto.TrafficUpdates.CourierPositionsResponse} returns this
*/
proto.TrafficUpdates.CourierPositionsResponse.prototype.setCourierPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.TrafficUpdates.CourierPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrafficUpdates.CourierPosition}
 */
proto.TrafficUpdates.CourierPositionsResponse.prototype.addCourierPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.TrafficUpdates.CourierPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrafficUpdates.CourierPositionsResponse} returns this
 */
proto.TrafficUpdates.CourierPositionsResponse.prototype.clearCourierPositionsList = function() {
  return this.setCourierPositionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.TrafficUpdates.CouriersLastPositionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrafficUpdates.CouriersLastPositionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    courierIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    countryCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrafficUpdates.CouriersLastPositionsRequest;
  return proto.TrafficUpdates.CouriersLastPositionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrafficUpdates.CouriersLastPositionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCourierIds(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrafficUpdates.CouriersLastPositionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrafficUpdates.CouriersLastPositionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourierIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated int32 courier_ids = 1;
 * @return {!Array<number>}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.getCourierIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest} returns this
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.setCourierIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest} returns this
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.addCourierIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest} returns this
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.clearCourierIdsList = function() {
  return this.setCourierIdsList([]);
};


/**
 * optional string country_code = 2;
 * @return {string}
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.TrafficUpdates.CouriersLastPositionsRequest} returns this
 */
proto.TrafficUpdates.CouriersLastPositionsRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.TrafficUpdates.CouriersLastPositionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TrafficUpdates.CouriersLastPositionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    couriersPositionsList: jspb.Message.toObjectList(msg.getCouriersPositionsList(),
    proto.TrafficUpdates.CourierPosition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsResponse}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.TrafficUpdates.CouriersLastPositionsResponse;
  return proto.TrafficUpdates.CouriersLastPositionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TrafficUpdates.CouriersLastPositionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsResponse}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.TrafficUpdates.CourierPosition;
      reader.readMessage(value,proto.TrafficUpdates.CourierPosition.deserializeBinaryFromReader);
      msg.addCouriersPositions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.TrafficUpdates.CouriersLastPositionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TrafficUpdates.CouriersLastPositionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCouriersPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.TrafficUpdates.CourierPosition.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CourierPosition couriers_positions = 1;
 * @return {!Array<!proto.TrafficUpdates.CourierPosition>}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.getCouriersPositionsList = function() {
  return /** @type{!Array<!proto.TrafficUpdates.CourierPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.TrafficUpdates.CourierPosition, 1));
};


/**
 * @param {!Array<!proto.TrafficUpdates.CourierPosition>} value
 * @return {!proto.TrafficUpdates.CouriersLastPositionsResponse} returns this
*/
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.setCouriersPositionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.TrafficUpdates.CourierPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrafficUpdates.CourierPosition}
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.addCouriersPositions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.TrafficUpdates.CourierPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TrafficUpdates.CouriersLastPositionsResponse} returns this
 */
proto.TrafficUpdates.CouriersLastPositionsResponse.prototype.clearCouriersPositionsList = function() {
  return this.setCouriersPositionsList([]);
};


goog.object.extend(exports, proto.TrafficUpdates);
